import { API_BASE_URL } from './environment';
import type { SelectOrganizationResponse } from './types';

export async function selectOrganization(args: { sessionId: string; organizationId: string; approve?: boolean }): Promise<SelectOrganizationResponse> {
  const url = new URL('/oauth/select-organization', API_BASE_URL).toString();
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      session_id: args.sessionId,
      organization_id: args.organizationId,
      approve: args.approve ?? true,
    }),
  });

  const contentType = response.headers.get('content-type') || '';
  const text = await response.text().catch(() => '');

  if (!response.ok) {
    throw new Error(`Failed to select organization: ${response.status} ${response.statusText}${text ? ` - ${text}` : ''}`);
  }

  if (contentType.includes('application/json')) {
    try {
      return JSON.parse(text) as SelectOrganizationResponse;
    } catch {
      // fall through
    }
  }

  // Some implementations may return a redirect URL as plain text.
  return { redirect_to: text };
}
